import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { pxToRem } from '@withjoy/joykit/theme';
import { usePageSettingsDialogContext } from '@apps/registry/admin/routes/YourRegistry/components/PageSettingsDialog/PageSettingsDialog.provider';

const StatusBadge = (props: { children: React.ReactNode }) => {
  return (
    <Flex
      cursor={'pointer'}
      alignItems={'center'}
      justifyContent={'space-around'}
      columnGap={2}
      borderRadius={5}
      backgroundColor={'mono2'}
      color={'mono12'}
      transition={animationTransition('background-color', 'color')}
      _hover={{ backgroundColor: 'white', color: 'linkHover' }}
      _active={{ backgroundColor: 'mono2', color: 'linkActive' }}
      {...props}
    />
  );
};

export type StatusBadgeItemProps = {
  label: string;
  icon: React.ReactNode;
  link?: string;
  onClick?: () => void;
  opensSettingsDialog?: boolean;
};

const Item: React.FC<StatusBadgeItemProps> = ({ label, icon, link, opensSettingsDialog, onClick, ...props }) => {
  const { openPageSettingsDialog } = usePageSettingsDialogContext();

  const handleOnClick = () => {
    if (opensSettingsDialog) {
      openPageSettingsDialog();
    }
    onClick?.();
  };

  return (
    <Flex
      flexGrow={1}
      height={pxToRem(29)}
      justifyContent={'center'}
      alignItems={'center'}
      columnGap={2}
      borderLeft={'1px solid'}
      borderColor={'mono1'}
      _firstChild={{ borderLeft: 'none' }}
      onClick={handleOnClick}
      {...(link && {
        cursor: 'pointer',
        as: 'a',
        href: link
      })}
      {...props}
    >
      {icon}
      <Box>
        <TextV2 typographyVariant={'label1'} flexGrow={1}>
          {label}
        </TextV2>
      </Box>
    </Flex>
  );
};

StatusBadge.Item = Item;

export { StatusBadge };
